import { Injectable } from '@angular/core';
import { ToasterService, ToasterConfig, Toast, BodyOutputType } from 'angular2-toaster';

@Injectable()
export class MyToasterService {

	constructor(private toasterService: ToasterService) {
	}

	config: ToasterConfig = new ToasterConfig({
		positionClass: 'toast-top-center',
		timeout: 10000,
		newestOnTop: true,
		tapToDismiss: true,
		preventDuplicates: true,
		animation: 'slideUp',
		limit: 5,
		showCloseButton: true,
		bodyOutputType: BodyOutputType.TrustedHtml,
	});
	type = 'default';

	types: string[] = ['default', 'info', 'success', 'warning', 'error'];
	animations: string[] = ['fade', 'flyLeft', 'flyRight', 'slideDown', 'slideUp'];
	//positions: string[] = ['toast-top-full-width', 'toast-bottom-full-width', 'toast-top-left', 'toast-top-center',
	//'toast-top-right', 'toast-bottom-right', 'toast-bottom-center', 'toast-bottom-left', 'toast-center'];



	public loading: false | { title: string; subTitle?: string } = false;

	/**
	 * showToast
	 *
	 * Exibe um novo toast
	 *
	 * @access public
	 * @author Murilo Spinoza de Arruda
	 * @since  03/2018
	 * @param  string
	 * @param  string
	 * @param  string
	 * @return void
	 */
	showToast(type: string, title: string, body: string) {

		const toast: Toast = {
			type: type,
			title: title,
			body: body,
		};
		this.toasterService.popAsync(toast);
	}

	/**
	 * showSuccessToast
	 *
	 * Exibe um novo toast do tipo success
	 *
	 * @access public
	 * @author Murilo Spinoza de Arruda
	 * @since  03/2018
	 * @param  string
	 * @param  string
	 * @return void
	 */
	showSuccessToast(title: string, body: string = '') {

		this.showToast('success', title, body);
	}

	/**
	 * showWarningToast
	 *
	 * Exibe um novo toast do tipo warning
	 *
	 * @access public
	 * @author Murilo Spinoza de Arruda
	 * @since  03/2018
	 * @param  string
	 * @param  string
	 * @return void
	 */
	showWarningToast(title: string, body: string = '') {

		this.showToast('warning', title, body);
	}

	/**
	 * showErrorToast
	 *
	 * Exibe um novo toast do tipo error
	 *
	 * @access public
	 * @author Murilo Spinoza de Arruda
	 * @since  03/2018
	 * @param  string
	 * @param  string
	 * @return void
	 */
	showErrorToast(title: string, body: string = '') {

		this.showToast('error', title, body);
	}

	/**
	 * showCompletionToast
	 *
	 * Exibe um toast para indicar o erro de preenchimento do formulario
	 *
	 * @access public
	 * @author Murilo Spinoza de Arruda
	 * @since  03/2018
	 * @return void
	 */
	showCompletionToast() {
		this.showWarningToast('Por favor, verifique o preenchimento dos campos', '');
	}

	/**
	 * showGetErrorToast
	 *
	 * Exibe um toast para indicar um erro na busca de dados
	 *
	 * @access public
	 * @author Murilo Spinoza de Arruda
	 * @since  03/2018
	 * @return void
	 */
	showGetErrorToast(error) {
		this.showErrorToast('Ocorreu um erro ao buscar os dados', error);
	}

	/**
	 * showSaveSuccessToast
	 *
	 * Exibe um toast para indicar o sucesso do salvar
	 *
	 * @access public
	 * @author Murilo Spinoza de Arruda
	 * @since  03/2018
	 * @return void
	 */
	showSaveSuccessToast() {
		this.showSuccessToast('Dados salvos com sucesso', '');
	}

	/**
	 * showSaveErrorToast
	 *
	 * Exibe um toast para indicar o sucesso do salvar
	 *
	 * @access public
	 * @author Murilo Spinoza de Arruda
	 * @since  03/2018
	 * @return void
	 */
	showSaveErrorToast(error) {
		this.showErrorToast('Dados não salvos', error);
	}
	/**
	 * showLoading
	 *
	 * Mostra o toaster e ativa a camada branca que cobre o form 
	 *
	 * @access public
	 * @author Murilo Spinoza de Arruda
	 * @since  06/2018
	 * @return void
	 */
	public showLoading(title: string, subTitle?: string) {

		//Mostra a camada branca
		this.loading = {
			title: title,
			subTitle: subTitle
		};
	}

	/**
	 * hideLoading
	 *
	 * Esconde o toaster e a camada branca que cobre o form 
	 *
	 * @access public
	 * @author Murilo Spinoza de Arruda
	 * @since  06/2018
	 * @return void
	 */
	public hideLoading() {

		//Esconde a camada branca
		this.loading = false;
	}
}



// WEBPACK FOOTER //
// ./src/services/my-toaster.service.ts